// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2qCQq","col":"CardReaderDesc_col__3SsC2","label":"CardReaderDesc_label__1wSBH"};